import { Header, StyledBlock, StyledDivider } from './block.styles'
import type { BlockProps } from './block.types'

export function Block({
  children,
  className,
  variant,
  description,
  divider = false,
  header,
  disablePadding
}: Readonly<BlockProps>) {
  return (
    <StyledBlock
      className={`tds-mode-variant-${variant} ${className ?? ''} ${
        !disablePadding ? 'tds-u-p2' : ''
      }`}
      disablePadding={disablePadding}
    >
      {header && <Header>{header}</Header>}
      {description && <span>{description}</span>}
      {(header || description) && divider && (
        <StyledDivider variant='discrete' className='tds-u-mb3' />
      )}
      {children}
    </StyledBlock>
  )
}
